import React, { useMemo } from 'react';
import {
  Card, Form, Row, Col, Button, Stack,
} from 'react-bootstrap';

import DownloadLink from '../common/DownloadLink';
import { getProjectTypeText } from '../../helpers/typeProject';

export default function BuyFormButtons({
  buy, can, readOnly, actions, hasApprovedPlans, strategyType,
}) {
  return (
    <Card className="mt-4">
      <Card.Body className="p-4">
        <Row>
          <Stack direction="horizontal">
            <Form.Group as={Col}>
              { can.SendTo1S && <Button className="me-2" variant="outline-secondary" onClick={actions.sendTo1S}>Отправить в 1С</Button>}
              { can.RequestEdit && buy.current && <Button className="me-2" variant="outline-secondary" onClick={actions.requestEdit}>Запрос на изменение</Button>}
              { can.Edit && !readOnly && <Button className="me-2" variant="primary" type="submit">Сохранить</Button>}
              { !!buy.id && can.SendToStrat && !can.Edit && (
                <Button className="me-2" variant="outline-warning" onClick={actions.sendToStrat}>
                  Отправить руководителю
                  {' '}
                  {getProjectTypeText(strategyType)}
                </Button>
              )}
              { !!buy.id && can.SendToStrat && can.Edit && (
                <Button className="me-2" variant="outline-warning" onClick={actions.saveAndSendToStrat}>
                  Сохранить и отправить руководителю
                  {' '}
                  {getProjectTypeText(strategyType)}
                </Button>
              )}
              {/* { !!buy.id && can.SendToStrat && !hasApprovedPlans
                && (
                  <PopoverElement tooltip="Отправка закупок на согласование возможна только при одобренном бюджете проекта на текущий год" disabled>
                    <Button className="me-2" variant="outline-warning" onClick={actions.saveAndSendToStrat} disabled>Сохранить и отправить руководителю {getProjectTypeText(projectParent)}</Button>
                  </PopoverElement>
                )} */}
              { !!buy.id && can.SendToPortf && !can.Edit && <Button className="me-2" variant="outline-warning" onClick={actions.sendToPortf}>Отправить руководителю Портфеля</Button>}
              { !!buy.id && can.SendToPortf && can.Edit && <Button className="me-2" variant="outline-warning" onClick={actions.saveAndSendToPortf}>Сохранить и отправить руководителю Портфеля</Button>}
              {/* { !!buy.id && can.SendToPortf && !hasApprovedPlans
                && (
                  <PopoverElement tooltip="Отправка закупок на согласование возможна только при одобренном бюджете проекта на текущий год" disabled>
                    <Button className="me-2" variant="outline-warning" onClick={actions.saveAndSendToPortf} disabled>Сохранить и отправить руководителю Портфеля</Button>
                  </PopoverElement>
                )} */}
              { (can.PortfReturn || can.StratReturn || can.SecyReturn) && <Button className="me-2" variant="outline-danger" onClick={actions.returnToProj}>Отправить на доработку</Button>}
              { can.SendToSecy && <Button className="me-2" variant="outline-warning" onClick={actions.sendToSecy}>{buy.policyId ? 'Отправить секретарю' : 'Согласовать'}</Button>}
              {/* { can.SendToSecy && !hasApprovedPlans
                  && (
                      <PopoverElement tooltip="Отправка закупок секретарю возможна только при одобренном бюджете проекта на текущий год" disabled>
                        <Button className="me-2" variant="outline-warning" onClick={actions.sendToSecy} disabled>{buy.policyId ? 'Отправить секретарю' : 'Согласовать'}</Button>
                      </PopoverElement>
                  )} */}
              {/* { can.SecyReturn && <Button className="me-2" variant="outline-danger" onClick={actions.returnToStrat}>Отправить на доработку</Button>} */}
              {!!buy.id && buy.current && (
                <DownloadLink
                  variant="outline-secondary"
                  url={`/buys/${buy.id}/teos/download`}
                  filename={`шаблон-тэо-${buy.num}.xlsx`}
                >
                  Скачать шаблон ТЭО
                </DownloadLink>
              )}
              {/* {!!buy.id && buy.status !== 'approved' && !readOnly && <Button className="me-2" variant="outline-danger" onClick={actions.delete}>Удалить</Button>} */}
            </Form.Group>
            { can.ViewVersions && !!buy.id && <Button className="me-2" variant="outline-secondary" onClick={actions.viewVersions}>История версий</Button>}
          </Stack>
        </Row>
      </Card.Body>
    </Card>
  );
}
